export const isWebp = (url: string) => !!url.match(/\.webp$/);

export const isJpg = (url: string) => !!url.match(/\.(jpeg|jpg)$/);

export const isPng = (url: string) => !!url.match(/\.png$/);
